import { t } from '../../i18next';
import { postRequest } from '../../shared/utils';

export const CommitHandler = async (props) => {
  const { deletedRow, editedRow, addedRow, configSchema, userDetails, tableDetails } = props;
  const resultSet = { success: true, errors: [] };
  const editedRecord = getEditedRowLogic({ editedRow });
  const addedRecord = getAddedRowLogic({ addedRow, userDetails });
  const inserObjArr = [...addedRecord.new];
  const deleteObjArr = [
    ...editedRecord.delete.map((item) => item.id),
    ...deletedRow.map((item) => item.roles_to_screen_grid_features_id),
  ];

  try {
    const resp = await postRequest('/api/tables', {
      screenGridId: tableDetails.id,
      tables: [
        {
          schema: configSchema,
          table: 'mbd_roles_to_screen_grid_features',
          pkey: tableDetails.mbdDataGrid.dataGridUniqueIdentifier,
          insertObjects: inserObjArr,
          deleteIds: deleteObjArr,
        },
      ],
    });
    if (resp.errors) {
      resultSet.errors.push({
        message: t('npiSteering.insert_upsert_error', {
          htz: 'data',
          msg: resp.errors[0]?.message,
        }),
      });
      resultSet.success = false;
    }
  } catch (error) {
    resultSet.errors.push({
      message: t('npiSteering.insert_upsert_error', {
        htz: 'data',
        msg: error.message,
      }),
    });
    resultSet.success = false;
  }
  return resultSet;
};

const getEditedRowLogic = ({ editedRow }) => {
  return editedRow.reduce(
    (resp, item) => {
      if (item['access_level'] === 'H') {
        const deleteRecord = {
          id: item.roles_to_screen_grid_features_id,
        };
        resp.delete.push(deleteRecord);
      }
      return resp;
    },
    { delete: [] },
  );
};

const getAddedRowLogic = ({ addedRow, userDetails }) => {
  return addedRow.reduce(
    (resp, item) => {
      if (item['access_level'] === 'S') {
        const newRecord = {
          role_id: item.role_id,
          screen_grid_feature_id: item.screen_grid_feature_id,
          access_level: 'S',
          created_by: userDetails.userId,
          updated_by: userDetails.userId,
          update_date: new Date().toISOString().substring(0, 19),
        };
        resp.new.push(newRecord);
      }

      return resp;
    },
    { new: [] },
  );
};
